module.exports = __webpack_public_path__ + "img/img_index_banner_x6@2x.898b2bf3.png";